import type { Dict } from '@aviata/platform-types';
import type { IATA } from '../types';

export function getCityByAirport(airportIata: IATA, dict: Dict.Entity) {
  return dict.airports[airportIata]?.city;
}

export function getCity(cityIata: IATA, dict: Dict.Entity) {
  return dict.cities[cityIata];
}

export function getAirline(airlineIata: IATA, dict: Dict.Entity) {
  return dict.airlines[airlineIata];
}

export function getAirport(airportIata: IATA, dict: Dict.Entity) {
  return dict.airports[airportIata];
}
